// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"535":"dc7850e0","744":"5576d7f4","879":"516381de"}[chunkId] + ".css";
};